import { prefixes, prependIntlIds } from "../utils";

export const unprefixedToastMessages = {
  "admin.app_table.fetch.plural.failure":
    "Při načítání seznamu tabulek došlo k chybě",

  "admin.app_table.name.fetch.plural.failure":
    "Při načítání jmen tabulek došlo k chybě",

  "admin.datasource.fetch.singular.failure":
    "Při načítání datového zdroje došlo k chybě",

  "admin.datasource.save.singular.failure":
    "Při ukládání datového zdroje došlo k chybě",

  "admin.datasource.save.singular.success": "Datový zdroj uložen",

  "admin.function.import.singular.failure":
    "Při importování funkce došlo k chybě",

  "admin.function.save.singular.failure": "Při ukládání funkce došlo k chybě",

  "admin.module.fetch.plural.failure":
    "Při načítání seznamu modulů došlo k chybě",

  "admin.module.save.singular.failure": "Při ukládání modulu došlo k chybě",

  "admin.role.save.singular.failure": "Při ukládání role došlo k chybě",

  "admin.template.apply_version.singular.failure":
    "Failed to apply template version",

  "admin.tBuilder.autosettingDataTemplateItemAsStaticSelect":
    "Zvolením dynamického výběru/výběru z přehledu se automaticky nastavil " +
    "vztah sloupce v datovém modelu jako statický. V případech, kdy toto nastevní " +
    "nevyhovuje, je nutné vztah v datovém modelu ručně změnit.",

  "admin.template.copy.singular.failure":
    "Při kopírování šablony došlo k chybě",

  "admin.template.import.singular.failure":
    "Při importování šablony došlo k chybě",

  "admin.template.save.singular.failure": "Při ukládání šablony došlo k chybě",

  "admin.user.save.singular.failure": "Při ukládání uživatele došlo k chybě",

  advanced_search_search_incomplete_datetime_input_value:
    "Nebylo možné spustit vyhledávání, protože některé z dat bylo vyplněné jen částečně",

  copy_text_to_clipboard: "Text byl zkopírovaný do schránky, použijte ctrl + v",

  "datasource.fetch.plural.failure":
    "Při načítání datových zdrojů došlo k chybě",
  "datasource.fetch.singular.failure":
    "Při načítání datového zdroje došlo k chybě",

  "detail.fetch.plural.failure": "Při získávání detailů došlo k chybě",
  "detail.fetch.singular.failure": "Při získávání detailu došlo k chybě",

  "detail.prefill.singular.failure":
    "Při získávání hodnot k předvyplnění detailu došlo k chybě",

  "detail.fetch.unauthorized.singular.failure":
    "Nelze zobrazit detail, protože nemáte oprávnění k detailové šabloně. Oprávnění Vám může přiřadit administrátor",

  "detail.save.plural.failure": "Při ukládání detailů došlo k chybě",
  "detail.save.singular.failure": "Při ukládání detailu došlo k chybě",

  "feedback.bug_report.submit.singular.failure":
    "Při nahlašování problémou došlo k chybě",
  "feedback.bug_report.submit.singular.success": "Chyba byla nahlášena",

  "feedback.submit.singular.failure":
    "Při odesílání zpětné vazby došlo k chybě",
  "feedback.submit.singular.success": "Zpětná vazba odeslána",

  "file.duplicate": "Soubor {fileName} již byl v seznamu přítomný",
  "file.rejected.wrong_type":
    "Soubory ({names}) nebyly nahrány, protože nejsou povolovaného typu",
  "file.rejected.too_large":
    "Soubory ({names}) nebyly nahrány, protože přesahují maximální povolenou velikost {kb}KB",
  "file.rejected.too_many":
    "Nelze přiložit víc než {max} souborů. Soubory ({names}) nebyly nahrány",

  "filter.create_new.singular.failure":
    "Při tvorbě filtru [{name}] došlo k chybě",
  "filter.create_new.singular.success": "Filtr [{name}] byl vytvořen",

  "filter.delete.singular.failure": "Při mazání filtru [{name}] došlo k chybě",
  "filter.delete.singular.success": "Filtr [{name}] byl smazán",

  "filter.edit.singular.failure": "Při úpřavě filtru [{name}] došlo k chybě",
  "filter.edit.singular.success": "Filtr [{name}] byl upraven",

  "filter.fetch.plural.failure": "Při získávání filtrů došlo k chybě",

  "function.deserializeParams.singular.failure":
    "Došlo k chybě při získávání parametrů funkce",

  "function.run.plural.failure": "Pří spoušení funkcí ({count}) došlo k chybě",
  "function.run.plural.success": "Funkce ({count}) proběhly úspěšně",
  "function.run.singular.failure": "Při spouštění funkce došlo k chybě",
  "function.run.singular.success": "Funkce proběhla úspěšně",

  "function.run.singular.warning": "Funkce neproběhla úspěšně",

  "heg_mapping.delete.singular.failure":
    "Během odmapovávání heg uživatele došlo k chybě",

  "heg_mapping.submit_username.singular.failure":
    "Během mapování heg uživatele došlo k chybě",

  "item_table.item_template_info.fetch.singular.failure":
    "Došlo k chybě při získávání kritérií definujících položky pro danou šablonu",

  "license.invalid_license.singular.failure": "Neplatná licence",

  "login.get_available_provider.plural.failure":
    "Došlo k chybě při načítání přihlašovacích metod",

  "password.change.singular.failure":
    "Změna hesla se nezdařila. Kontaktujte prosím administrátora",
  "password.change.singular.success": "Změna hesla proběhla úspěšně",

  "password.reset.singular.failure":
    "Při resetování hesla uživatele {login} došlo k chybě",
  "password.reset.singular.success":
    "Uživateli {login} byl odeslán odkaz pro obnovu hesla na email {email}",

  "password.reset.plural.failure": "Hromadné resetování hesla selhalo",
  "password.reset.plural.success": "Hromadné resetování hesla proběhlo úspěšně",

  "password.reset.no_email":
    "Pro uživatele [{users}] nemohlo být heslo resetováno, protože nemají vyplněný email",

  "record.add.singular.failure": "Při přidávání záznamu došlo k chybě",
  "record.add.singular.success": "Záznam byl přidán",

  "record.delete.singular.failure": "Při odstraňování záznamu došlo k chybě",
  "record.delete.singular.success": "Záznam byl odstraněn",

  "record.edit.singular.failure": "Při editaci záznamu došlo k chybě",
  "record.edit.singular.success": "Záznam byl editován",

  "relation_table.fetch.singular.failure":
    "Při načítaní dat pro relační tabulku došlo k chybě",

  "request.transform_response.singular.failure":
    "Došlo k chybě při interpretaci odpovědi serveru",

  "settings.fetch.singular.failure": "Při načítání nastavení došlo k chybě",

  "settings.save.singular.failure": "Při ukládání nastavení došlo k chybě",
  "settings.save.singular.success": "Nastavení bylo uloženo",

  "table.data.fetch.singular.failure": "Při načítání dat tabulky došlo k chybě",

  "table.rpp.fetch.singular.failure":
    "Při načítání stránkování tabulky došlo k chybě",
  "table.rpp.save.singular.failure":
    "Při ukládání stránkování tabulky došlo k chybě",

  "templateBuilder.fetch.singular.failure": "Načítání modelu šablony selhalo",

  "templateBuilder.save.singular.failure": "Ukládání modelu šablony selhalo",
  "templateBuilder.save.singular.success": "Model šablony uložen",

  "templateBuilder.sqlQuery.fetch.singular.failure":
    "Při načítání SQL dotazu došlo k chybě",

  "user_settings.fetch.singular.failure":
    "Při načítání uživatelského nastavní došlo k chybě",

  "user_settings.update.singular.failure":
    "Při ukládání uživatelského nastavní došlo k chybě",

  // HWR
  "hwr.loading.singular.failure": "Při načítání došlo k chybě",
  "hwr.table.fetch_and_set.singular.failure":
    "Při získávání tabulky {name} došlo k chybě",
  "hwr.save.singular.failure": "Při ukládání dat došlo k chybě",

  // Reporting Services
  "reportingServices.loading.singular.failure":
    "Při načítání reportu došlo k chybě",
  "reportingServices.loading_params.singular.failure":
    "Při načítání parametrů reportu došlo k chybě",

  // TemplateTable
  "templateTable.delete.singular.failure": "Při mazání došlo k chybě.",
  "templateTable.delete.singular.success": "Záznam byl úspěšně smazán.",

  // Login
  "login.singular.failure": "Chyba při přihlašování:",
  "login.login_options.failure":
    "Při načítání možností přihlášení došlo k chybě.",
  "login.google_modal.failure": "Chyba při získávání informací z Google",
  "login.microsoft_modal.failure": "Chyba při získávání informací z Microsoft",
  "login.google.failure":
    "Uživatel s tímto emailem neexistuje, pro další kroky kontaktuje administrátora.",
};

export default prependIntlIds(prefixes.toast, unprefixedToastMessages);
